// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
// import { getAnalytics } from "firebase/analytics";
import { getFirestore } from "firebase/firestore";
export const firebaseConfig = {
  apiKey: "AIzaSyCvn8cS6SQMiw-hYM0ynSHTQv3I5_dWvNw",
  authDomain: "promotional-tool.firebaseapp.com",
  projectId: "promotional-tool",
  storageBucket: "promotional-tool.appspot.com",
  messagingSenderId: "529461686432",
  appId: "1:529461686432:web:ea781579a9bcba8300d9c5",
  measurementId: "G-JERPY6TXSY",
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
// const analytics = getAnalytics(app);

// Initialize Cloud Firestore and get a reference to the service
const db = getFirestore(app);
export default db;
